"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Text_1 = __importStar(require("../../../Text"));
const DropdownMenuCreatableItem_1 = __importDefault(require("../DropdownMenuCreatableItem"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const NotFoundCreatableLabel = ({ onCreate, palette, size, defaultValue, }) => ((0, jsx_runtime_1.jsxs)("div", { className: styles_module_css_1.default.notFoundCreatableWrapper, children: [(0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.notFoundCreatableText, children: (0, jsx_runtime_1.jsx)(Text_1.default, { preset: Text_1.TextPresets.BodyBold12, color: Text_1.TextColors.Blue, children: "+ Add custom item:" }) }), (0, jsx_runtime_1.jsx)(DropdownMenuCreatableItem_1.default, { readOnly: true, defaultValue: defaultValue, onCreate: onCreate, palette: palette, size: size })] }));
exports.default = NotFoundCreatableLabel;
